<template>
  <div class="py-5 border-b border-gray-200">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">{{ head }}</h3>
        <p class="mt-1 text-sm text-gray-500">
          <slot>Lorem ipsum dolor sit amet consectetur adipisicing elit quam corrupticonsectetur.</slot>
        </p>
      </div>
      <div class="ml-4 mt-4 flex-shrink-0">
        <slot name="button">
        <button type="button" @click="$emit('btn')" v-if="btnText"
                class="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
          {{ btnText }}
        </button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    head: {
      default: 'Section header'
    },
    btnText: {
      default: false
    }
  },
  emits: ['btn']

}
</script>